import React, { useState } from "react";
import { connect } from "react-redux";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import ProcedimientoActions from "../../../stores/procedimiento/Actions";
import PrestadorActions from "../../../stores/prestador/Actions";
import VoucherActions from "../../../stores/voucher/Actions";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import DetalleAfiliado from "../components/DetalleAfiliado";
import DetalleAutorizacion from "../components/DetalleAutorizacion";
import ProcedimientosModal from "../components/ProcedimientosModal";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomTable from "../../../components/CustomTable/CustomTable";
import TittleLine from "../../../components/Common/TittleLine";
import { AutorizacionFormButtonsContainer } from "../styles/AutorizacionStyles";
import {
  columnsProcedimientosDetalle,
  columnsProcedimientosDetalleMadre,
  DEFAULT_ICON_AVATAR,
  DATOS_FIJOS_AUTORIZACION,
  DEFAULT_ROW_DETAIL,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
  PAGINAS_PROCEDIMIENTOS,
  columnsProcedimientosPermitidos,
  CONFIG_VOUCHER,
  VOUCHER_AUTORIZACION,
  TIPO_ID,
} from "../utils/AutorizacionConstant";
import {
  getTipoServicioTipoCobertura,
  parseStringAutorizacion,
  getMontoTotalReclamado,
  getMontoAutorizadoPrimera,
  getMontoAutorizadoHumano,
  getMontoAutorizadoTotal,
  getMontoDiferencia,
} from "../utils/AutorizacionUtils";
import useEmpresa from "../../../hooks/useEmpresa";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import { useLocation, useParams } from "react-router-dom";

import { isObjectEmpty } from "../../../utils/ObjectUtil";
import {
  formatCedula,
  formatPhoneNumber,
  isEmptyValue,
} from "../../../utils/StringUtil";
import { cleanNumber } from "../../../utils/NumberUtil";
import { getAge } from "../../../utils/DateUtils";
import { cleanCurrency, dotsAndNumbers } from "../../../utils/CurrencyUtil";
import { DATE_FORMATS } from "../../../utils/Constant";
import CustomAlert from "../../../components/Common/CustomAlert";
import ModalLoader from "../../../components/Common/ModalLoader";
import CheckRender from "../../../components/Common/CheckRender";
import moment from "moment";
import Colors from "../../../themes/Colors";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import { isValidNumber } from "../../../utils/ValidationUtil";

const DetalleAutorizacionScreen = (props) => {
  const empresa = useEmpresa();
  const location = useLocation();
  const { numeroAutorizacion: numeroAutorizacionParam, ano: anoParam } =
    useParams();
  const [processing, setProcessing] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [dataAutorizacion, setDataAutorizacion] = useState(null);
  const [dataAutorizacionGmm, setDataAutorizacionGmm] = useState(null);
  const [tablaProcedimientosData, setTablaProcedimientosData] = useState([]);
  const [procedimientosBusqueda, setProcedimientosBusqueda] = useState([]);
  const [isModalCoberturasOpen, setIsModalCoberturasOpen] = useState(false);
  const [showModalVouchers, setShowModalVouchers] = useState(false);
  const [isMatricialVoucher, setIsMatricialVoucher] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const itemsPerPage = PAGINAS_PROCEDIMIENTOS.TAMANO;
  const [currentPage, setCurrentPage] = useState(1);
  const [codigoCobertura, setCodigoCobertura] = useState("");
  const [montoCobertura, setMontoCobertura] = useState("");
  const [queryProcedimientos, setQueryProcedimientos] = useState("");

  let numeroAutorizacion = numeroAutorizacionParam;
  let ano = undefined;
  let esAutorizacionMadre = false;
  let infoAutorizacionMadre = undefined;
  let desdePantallaConsulta = false;
  let autorizacionesRelacionadas = undefined;
  let formData = undefined;

  if (location?.state?.autorizacion) {
    numeroAutorizacion = location.state.autorizacion.numeroAutorizacion;
    ano = location.state.autorizacion.ano;
    esAutorizacionMadre = location.state.esAutorizacionMadre;
    infoAutorizacionMadre = location.state.infoAutorizacionMadre;
    desdePantallaConsulta = location.state.desdePantallaConsulta;
    autorizacionesRelacionadas = location.state.autorizacionesRelacionadas;
    formData = location.state.formData;
  } else if (numeroAutorizacionParam) {
    numeroAutorizacion = numeroAutorizacionParam;
    ano = anoParam || new Date().getFullYear();
    desdePantallaConsulta = true;
  }

  useMountEffect(() => {
    if (esAutorizacionMadre && !desdePantallaConsulta) {
      autoCompletarAutorizacionMadre();
    } else {
      consultarDetalleAutorizacion();
    }
  });
  const processProcedimientosWithTotals = (procedimientos) => {
    if (!procedimientos || procedimientos.length === 0) {
      return [];
    }

    const procedimientosWithTotals = [...procedimientos];

    const lastRow =
      procedimientosWithTotals[procedimientosWithTotals.length - 1];
    if (lastRow && lastRow.nombreCobertura !== "Totales") {
      procedimientosWithTotals.push({
        key: "totales",
        cobertura: "",
        nombreCobertura: "Totales",
        cantidad: "",
        montoReclamado: getMontoTotalReclamado(procedimientos),
        montoAutorizado: getMontoAutorizadoTotal(procedimientos),
        montoDiferencia: getMontoDiferencia(procedimientos),
      });
    }

    return procedimientosWithTotals;
  };

  const processProcedimientosMadreWithTotals = (procedimientos) => {
    if (!procedimientos || procedimientos.length === 0) {
      return [];
    }

    const procedimientosWithTotals = [...procedimientos];

    const lastRow =
      procedimientosWithTotals[procedimientosWithTotals.length - 1];
    if (lastRow && lastRow.nombreCobertura !== "Totales") {
      procedimientosWithTotals.push({
        key: "totales",
        cobertura: "",
        nombreCobertura: "Totales",
        cantidad: "",
        montoReclamado: getMontoTotalReclamado(procedimientos),
        montoAutorizacionPrimera: getMontoAutorizadoPrimera(procedimientos),
        montoAutorizacionHumano: getMontoAutorizadoHumano(procedimientos),
        montoAutorizado: getMontoAutorizadoTotal(procedimientos),
        montoDiferencia: getMontoDiferencia(procedimientos),
      });
    }

    return procedimientosWithTotals;
  };
  /**
   * Obtener detalle de la autorización Success
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getAutorizacionData) && processing) {
      setProcessing(false);

      const {
        afiliado,
        fecha,
        procedimientos,
        usuarioIngreso,
        codigoServicio,
      } = props?.getAutorizacionData?.data;

      const {
        numeroPlastico,
        cedula,
        nss,
        nombres,
        apellidos,
        fechaNacimiento,
        nombrePss,
        plan,
      } = afiliado;

      const detalle = {
        numeroAfiliado: numeroPlastico,
        cedula: formatCedula(cedula),
        nss,
        nombres,
        apellidos,
        edad: getAge(fechaNacimiento),
        fecha: moment(fecha).format(DATE_FORMATS.middledash_ymd),
        telefono: formatPhoneNumber(afiliado?.telefono),
        tipoServicio: codigoServicio,
        correo: afiliado?.email,
        esArl: "No",
        medicoPrescriptor: nombrePss,
        diagnostico: DATOS_FIJOS_AUTORIZACION.CODIGO_DIAGNOSTICO_NO_CAPTURADO,
        usuarioIngreso: usuarioIngreso,
        foto: DEFAULT_ICON_AVATAR,
        plan,
      };

      setDataAutorizacion(detalle);

      if (
        desdePantallaConsulta &&
        props?.getAutorizacionData?.mostrarMontosMadre
      ) {
        const infoAutorizacionMadreDetalle =
          props?.getAutorizacionData?.infoAutorizacionMadre;

        if (
          infoAutorizacionMadreDetalle?.autorizacionMadreCoberturaSalud &&
          infoAutorizacionMadreDetalle?.autorizacionMadreCoberturaSalud
            ?.length > 0
        ) {
          const mappedProcedimientos =
            infoAutorizacionMadreDetalle?.autorizacionMadreCoberturaSalud?.map(
              (procedimiento) => {
                const {
                  cobertura,
                  cantidad,
                  descripcion,
                  montoReclamado,
                  montoAutorizacionPrimera,
                  montoAutorizacionHumano,
                  montoAutorizado,
                  montoAsegurado,
                } = procedimiento;
                return {
                  key: cobertura,
                  cobertura,
                  nombreCobertura: descripcion,
                  cantidad,
                  montoReclamado,
                  montoAutorizacionPrimera,
                  montoAutorizacionHumano,
                  montoAutorizado,
                  montoDiferencia: montoAsegurado,
                  esNuevo: false,
                };
              }
            );

          setTablaProcedimientosData(
            processProcedimientosMadreWithTotals(mappedProcedimientos)
          );
        }
      } else {
        const mappedProcedimientos = procedimientos.map((procedimiento) => {
          const {
            codigo,
            nombre,
            frecuencia,
            montoReclamado,
            montoARS,
            montoAfiliado,
          } = procedimiento;
          return {
            key: codigo,
            cobertura: codigo,
            nombreCobertura: nombre,
            cantidad: frecuencia,
            montoReclamado: montoReclamado,
            montoAutorizado: montoARS,
            montoDiferencia: montoAfiliado,
            esNuevo: false,
          };
        });

        setTablaProcedimientosData(
          processProcedimientosWithTotals(mappedProcedimientos)
        );
      }

      if (props?.getAutorizacionData?.info) {
        const {
          medicoTratante,
          tipoTelefono,
          telefono,
          email,
          diagnostico,
          indicadorFisicoExento,
          descripcionZona,
          descripcionProvincia,
          comentarios,
          diagnosticoMetaData,
        } = props?.getAutorizacionData?.info;

        const observaciones = comentarios?.length > 0 ? comentarios[0] : "";

        setDataAutorizacion((prevState) => {
          return {
            ...detalle,
            tipoTelefono: tipoTelefono,
            telefono: formatPhoneNumber(telefono),
            correo: email,
            medicoPrescriptor: medicoTratante,
            diagnostico: diagnostico,
            requiereFisico: indicadorFisicoExento ? "No" : "Si",
            zona: descripcionZona,
            provincia: descripcionProvincia,
            observaciones: observaciones,
            diagnosticoDefinitivo: diagnosticoMetaData?.esDiagnosticoDefinitivo,
          };
        });
      }

      setDataAutorizacionGmm(props?.getAutorizacionData?.dataGmm);
    }
  }, [props.getAutorizacionData]);
  /**
   * Reactivar autorización Success
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.reactivarAutorizacionData) && processing) {
      setProcessing(false);

      const { autorizacion } = props?.reactivarAutorizacionData;

      let procedimientos = autorizacion?.procedimientos?.map(
        (procedimiento) => {
          const {
            codigo,
            nombre,
            frecuencia,
            montoReclamado,
            montoARS,
            montoAfiliado,
          } = procedimiento;
          return {
            key: codigo,
            cobertura: codigo,
            nombreCobertura: nombre,
            cantidad: frecuencia,
            montoReclamado: montoReclamado,
            montoAutorizado: montoARS,
            montoDiferencia: montoAfiliado,
            esNuevo: false,
          };
        }
      );

      procedimientos = processProcedimientosWithTotals(procedimientos);

      if (editMode) {
        setTablaProcedimientosData((pre) => {
          return procedimientos;
        });
        setEditMode(false);
      } else {
        mostrarFilaEdicion(procedimientos);
        setEditMode(true);
      }
    }
  }, [props.reactivarAutorizacionData]);

  /**
   * Reactivar autorizacion Error..
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.reactivarAutorizacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.reactivarAutorizacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.reactivarAutorizacionError]);

  /**
   * Validar procedimiento Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.validarProcedimientoData) && processing) {
      setProcessing(false);

      setCodigoCobertura("");

      setMontoCobertura("");

      const {
        codigo,
        nombreCobertura,
        frecuencia,
        montoReclamado,
        montoArs,
        montoAfiliado,
        isFromModal,
      } = props?.validarProcedimientoData;

      setTablaProcedimientosData((pre) => {
        return [
          ...pre,
          {
            key: codigo,
            cobertura: codigo,
            nombreCobertura: nombreCobertura,
            cantidad: frecuencia,
            montoReclamado: montoReclamado,
            montoAutorizado: montoArs,
            montoDiferencia: montoAfiliado,
            esNuevo: true,
          },
        ];
      });

      isFromModal && handleCloseModalCoberturas();
    }
  }, [props.validarProcedimientoData]);

  /**
   * Validar procedimiento Error..
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.validarProcedimientoError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.validarProcedimientoError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.validarProcedimientoError]);

  /**
   * Crear Autorizacion Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.crearAutorizacionData) && processing) {
      setProcessing(false);

      const { autorizacion, mensajeProcedimientosNoInsertados } =
        props?.crearAutorizacionData;

      const { numeroAutorizacion } = autorizacion;

      ocultarFilaEdicion();

      setEditMode(false);

      setAlertConfig({
        type: "success",
        title: `¡Autorización ${numeroAutorizacion} guardada con éxito!`,
        message: `Reclamación enviada. (${numeroAutorizacion})`,
        aditionalInfo: mensajeProcedimientosNoInsertados,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
    }
  }, [props.crearAutorizacionData]);

  /**
   * Crear Autorizacion Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.crearAutorizacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.crearAutorizacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.crearAutorizacionError]);

  /**
   * Obtener procedimientos permitidos Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProcedimientosPssData) && processing) {
      setProcessing(false);

      const { coberturas } = props?.getProcedimientosPssData;

      setProcedimientosBusqueda(coberturas);

      setIsModalCoberturasOpen(true);
    }
  }, [props.getProcedimientosPssData]);

  /**
   * Obtener procedimientos permitidos Error..
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProcedimientosPssError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.getProcedimientosPssError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.getProcedimientosPssError]);

  /**
   * Get Voucher Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getVoucherData) && processing) {
      setProcessing(false);

      const isMatricial = props.getVoucherData?.voucherDataInfo?.isMatricial;

      const newTab = window.open(
        "/voucher",
        "_blank",
        isMatricial ? CONFIG_VOUCHER.MATRICIAL : CONFIG_VOUCHER.TERMICO
      );

      newTab.focus();
    }
  }, [props.getVoucherData]);

  /**
   * Get Voucher Gmm Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getVoucherGmmData) && processing) {
      setProcessing(false);

      const isMatricial =
        props.getVoucherGmmData?.voucherGmmDataInfo?.isMatricial;

      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;

      const leftPosition = screenWidth / 2;
      const topPosition = screenHeight / 2;

      const config = isMatricial
        ? CONFIG_VOUCHER.MATRICIAL
        : CONFIG_VOUCHER.TERMICO;

      const newTab = window.open(
        "/voucher-gmm",
        "_blank",
        `${config}top=${topPosition},left=${leftPosition}`
      );

      newTab.focus();
    }
  }, [props.getVoucherGmmData]);

  const handleOpenModalCoberturas = () => {
    setProcessing(true);

    setCurrentPage(PAGINAS_PROCEDIMIENTOS.PAGINA);

    props.getProcedimientosPss({
      servicio: dataAutorizacion?.tipoServicio,
      pagina: PAGINAS_PROCEDIMIENTOS.PAGINA,
      tamanoPagina: PAGINAS_PROCEDIMIENTOS.TAMANO,
      applyFilter: false,
    });
  };

  const handleCloseModalCoberturas = () => {
    setIsModalCoberturasOpen(false);
  };

  const handleCloseModalVouchers = () => {
    setShowModalVouchers(false);
  };

  const consultarDetalleAutorizacion = () => {
    setProcessing(true);

    props.getAutorizacion({
      numeroAutorizacion: numeroAutorizacion,
      tipoPss: props?.authUserData?.prestador?.tipoPss,
      codigoPss: props?.authUserData?.prestador?.codigo,
      ano: ano,
      desdePantallaConsulta: desdePantallaConsulta,
    });
  };

  const autoCompletarAutorizacionMadre = () => {
    setDataAutorizacion({
      ...formData,
      numeroAfiliado: infoAutorizacionMadre?.autorizacionMadre?.numeroPlastico,
    });
    if (
      infoAutorizacionMadre?.autorizacionMadreCoberturaSalud &&
      infoAutorizacionMadre?.autorizacionMadreCoberturaSalud?.length > 0
    ) {
      const mappedProcedimientos =
        infoAutorizacionMadre?.autorizacionMadreCoberturaSalud?.map(
          (procedimiento) => {
            const {
              cobertura,
              cantidad,
              descripcion,
              montoReclamado,
              montoAutorizacionPrimera,
              montoAutorizacionHumano,
              montoAutorizado,
              montoAsegurado,
            } = procedimiento;
            return {
              key: cobertura,
              cobertura,
              nombreCobertura: descripcion,
              cantidad,
              montoReclamado,
              montoAutorizacionPrimera,
              montoAutorizacionHumano,
              montoAutorizado,
              montoDiferencia: montoAsegurado,
              esNuevo: false,
            };
          }
        );

      setTablaProcedimientosData(
        processProcedimientosMadreWithTotals(mappedProcedimientos)
      );
    }
  };

  const imprimirVoucher = (isMatricial) => {
    if (
      esAutorizacionMadre ||
      (desdePantallaConsulta && props?.getAutorizacionData?.mostrarMontosMadre)
    ) {
      setIsMatricialVoucher(isMatricial);
      setShowModalVouchers(true);
      return;
    }
    const procedimientosSinTotales = tablaProcedimientosData.filter(
      (proc) => proc.key !== "totales"
    );
    
    const data = {
      numeroAutorizacion,
      dataAutorizacion,
      procedimientos: procedimientosSinTotales,
      isMatricial,
    };

    setProcessing(true);

    props.getVoucher(data);

    if (dataAutorizacionGmm) {
      setAlertConfig({
        type: "confirm",
        title: "Hola",
        message: `Se generó un voucher adicional, desea imprimirlo?`,
        onConfirm: () => {
          const dataGmm = {
            numeroAutorizacion: dataAutorizacionGmm?.numeroAutorizacion,
            dataAutorizacion: {
              ...dataAutorizacion,
              tipoServicio: dataAutorizacionGmm?.codigoServicio,
            },
            procedimientos: dataAutorizacionGmm?.procedimientos?.map(
              (procedimiento) => {
                const {
                  codigo,
                  nombre,
                  frecuencia,
                  montoReclamado,
                  montoARS,
                  montoAfiliado,
                } = procedimiento;
                return {
                  key: codigo,
                  cobertura: codigo,
                  nombreCobertura: nombre,
                  cantidad: frecuencia,
                  montoReclamado: montoReclamado,
                  montoAutorizado: montoARS,
                  montoDiferencia: montoAfiliado,
                  esNuevo: false,
                };
              }
            ),
            isMatricial,
          };

          setProcessing(true);
          props.getVoucherGmm(dataGmm);
          setShowAlert(false);
        },
        onCancel: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
    }
  };

  const descargarVoucherAsegurado = () => {
    const infoMadre =
      desdePantallaConsulta && props?.getAutorizacionData?.mostrarMontosMadre
        ? props?.getAutorizacionData?.infoAutorizacionMadre
        : infoAutorizacionMadre;

    if (infoMadre?.autorizacionMadre?.numeroMadre !== null) {
      const objetoAutorizacion = parseStringAutorizacion(
        infoMadre?.autorizacionMadre?.numeroMadre
      );

      const request = {
        name: isMatricialVoucher
          ? VOUCHER_AUTORIZACION.HUMANO_ASEGURADO_MATRICIAL
          : VOUCHER_AUTORIZACION.HUMANO_ASEGURADO_TERMICO,
        parameters: {
          P_ANO: `${objetoAutorizacion?.ano}`,
          P_COMPANIA: `${objetoAutorizacion?.compania}`,
          P_RAMO: `${objetoAutorizacion?.ramo}`,
          P_SECUENCIAL: `${objetoAutorizacion?.secuencial}`,
          P_TIPO_ID: TIPO_ID.PLASTICO,
          P_IDENTIFICACION: `${dataAutorizacion?.numeroAfiliado}`,
        },
      };

      props.descargarReporteVoucher(request);
    }
  };

  const descargarVoucherHumanoPrestador = () => {
    const infoMadre =
      desdePantallaConsulta && props?.getAutorizacionData?.mostrarMontosMadre
        ? props?.getAutorizacionData?.infoAutorizacionMadre
        : infoAutorizacionMadre;

    if (infoMadre?.autorizacionMadre?.numeroReclamacionHumano !== null) {
      const objetoAutorizacion = parseStringAutorizacion(
        infoMadre?.autorizacionMadre?.numeroReclamacionHumano
      );

      const request = {
        name: isMatricialVoucher
          ? VOUCHER_AUTORIZACION.HUMANO_PRESTADOR_MATRICIAL
          : VOUCHER_AUTORIZACION.HUMANO_PRESTADOR_TERMICO,
        parameters: {
          P_ANO: `${objetoAutorizacion?.ano}`,
          P_COMPANIA: `${objetoAutorizacion?.compania}`,
          P_RAMO: `${objetoAutorizacion?.ramo}`,
          P_SECUENCIAL: `${objetoAutorizacion?.secuencial}`,
          P_TIPO_ID: TIPO_ID.PLASTICO,
          P_IDENTIFICACION: `${dataAutorizacion?.numeroAfiliado}`,
        },
      };

      props.descargarReporteVoucher(request);
    }
  };

  const descargarVoucherPrimeraPrestador = () => {
    const infoMadre =
      desdePantallaConsulta && props?.getAutorizacionData?.mostrarMontosMadre
        ? props?.getAutorizacionData?.infoAutorizacionMadre
        : infoAutorizacionMadre;

    if (infoMadre?.autorizacionMadre?.numeroReclamacionPrimera !== null) {
      const objetoAutorizacion = parseStringAutorizacion(
        infoMadre?.autorizacionMadre?.numeroReclamacionPrimera
      );

      const request = {
        name: isMatricialVoucher
          ? VOUCHER_AUTORIZACION.PRIMERA_PRESTADOR_MATRICIAL
          : VOUCHER_AUTORIZACION.PRIMERA_PRESTADOR_TERMICO,
        parameters: {
          P_ANO: `${objetoAutorizacion?.ano}`,
          P_COMPANIA: `${objetoAutorizacion?.compania}`,
          P_RAMO: `${objetoAutorizacion?.ramo}`,
          P_SECUENCIAL: `${objetoAutorizacion?.secuencial}`,
          P_TIPO_ID: TIPO_ID.PLASTICO,
          P_IDENTIFICACION: `${dataAutorizacion?.numeroAfiliado}`,
        },
      };

      props.descargarReporteVoucher(request);
    }
  };

  const descargarTodo = () => {
    descargarVoucherAsegurado();
    descargarVoucherHumanoPrestador();
    descargarVoucherPrimeraPrestador();
  };

  const onChangeCodigoCobertura = (value) => {
    setCodigoCobertura(cleanNumber(value));
  };

  const onChangeMontoCobertura = (value) => {
    setMontoCobertura(cleanCurrency(value));
  };

  const mostrarFilaEdicion = (procedimientos) => {
    let procedimientosData = procedimientos;
    if (
      procedimientosData.length > 0 &&
      procedimientosData[procedimientosData.length - 1].key === "totales"
    ) {
      procedimientosData = procedimientosData.slice(0, -1);
    }

    procedimientosData.unshift(DEFAULT_ROW_DETAIL);
    procedimientosData = processProcedimientosWithTotals(procedimientosData);

    setTablaProcedimientosData((pre) => {
      return procedimientosData;
    });
  };
  const ocultarFilaEdicion = () => {
    let procedimientosData = tablaProcedimientosData;

    if (
      procedimientosData.length > 0 &&
      procedimientosData[procedimientosData.length - 1].key === "totales"
    ) {
      procedimientosData = procedimientosData.slice(0, -1);
    }

    procedimientosData.shift();

    procedimientosData = processProcedimientosWithTotals(procedimientosData);

    setTablaProcedimientosData((pre) => {
      return procedimientosData;
    });
  };

  const reactivar = () => {
    setProcessing(true);

    props.reactivarAutorizacion({
      numeroAutorizacion: numeroAutorizacion,
      anio: Number(props?.getAutorizacionData?.autorizacionLegacy?.anio),
    });
  };

  const procedimientoFueAgregado = (codigoProcedimiento) => {
    if (
      tablaProcedimientosData.some(
        (procedimiento) => procedimiento.cobertura === codigoProcedimiento
      )
    ) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `El pricedimiento ${codigoProcedimiento} ya fue agregado.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return true;
    }

    return false;
  };

  const agregarNuevoProcedimiento = () => {
    if (isEmptyValue(codigoCobertura)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor ingresar el código del procedimiento.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    if (procedimientoFueAgregado(Number(codigoCobertura))) {
      return;
    }

    const { numeroSesion } = props?.reactivarAutorizacionData;

    setProcessing(true);

    props.validarProcedimiento({
      numeroSesion: Number(numeroSesion),
      codigoProcedimiento: Number(codigoCobertura),
      tipoServicio: getTipoServicioTipoCobertura(
        dataAutorizacion?.tipoServicio
      ),
      isFromModal: false,
      monto: dotsAndNumbers(montoCobertura),
      frecuencia: 1,
      servicio: dataAutorizacion?.tipoServicio,
    });
  };

  const onQueryProcedimientosChange = () => (value) => {
    setQueryProcedimientos(value);
    onSearchProcedimientos(value);
  };

  const onClickProcedimientoModal = (record) => {
    const { nombreCobertura, cobertura } = record;

    const { numeroSesion } = props?.reactivarAutorizacionData;

    if (procedimientoFueAgregado(Number(cobertura))) {
      return;
    }

    setProcessing(true);

    props.validarProcedimiento({
      numeroSesion: Number(numeroSesion),
      codigoProcedimiento: Number(cobertura),
      tipoServicio: getTipoServicioTipoCobertura(
        dataAutorizacion?.tipoServicio
      ),
      nombreCobertura,
      isFromModal: true,
      monto: dotsAndNumbers(montoCobertura),
      frecuencia: 1,
      servicio: dataAutorizacion?.tipoServicio,
    });
  };

  const onSearchProcedimientos = (query) => {
    setProcessing(true);

    setCurrentPage(PAGINAS_PROCEDIMIENTOS.PAGINA);

    let requestProcedimientos = {
      servicio: dataAutorizacion?.tipoServicio,
      pagina: PAGINAS_PROCEDIMIENTOS.PAGINA,
      tamanoPagina: itemsPerPage,
      applyFilter: true,
    };

    if (isEmptyValue(query)) {
      props.getProcedimientosPss(requestProcedimientos);
      return;
    }

    if (isValidNumber(query)) {
      requestProcedimientos.cobertura = Number(query);
    } else {
      requestProcedimientos.nombreCobertura = query;
    }

    props.getProcedimientosPss(requestProcedimientos);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);

    setProcessing(true);

    let requestProcedimientos = {
      servicio: dataAutorizacion?.tipoServicio,
      pagina: page,
      tamanoPagina: itemsPerPage,
      applyFilter: false,
    };

    if (isEmptyValue(queryProcedimientos)) {
      props.getProcedimientosPss(requestProcedimientos);
      return;
    }

    if (isValidNumber(queryProcedimientos)) {
      requestProcedimientos.cobertura = Number(queryProcedimientos);
    } else {
      requestProcedimientos.nombreCobertura = queryProcedimientos;
    }

    props.getProcedimientosPss(requestProcedimientos);
  };

  const modificarAutorizacion = () => {
    const { numeroSesion } = props?.reactivarAutorizacionData;

    setProcessing(true);

    const procedimientos = tablaProcedimientosData?.filter(
      (item) => item.key !== DEFAULT_ROW_DETAIL.key && item.esNuevo
    );

    props.crearAutorizacion({
      numeroSesion: numeroSesion,
      tipoServicio: getTipoServicioTipoCobertura(
        dataAutorizacion?.tipoServicio
      ),
      requestAutorizar: {
        preAutorizar: true,
        esARL: dataAutorizacion?.esArl === "Si",
      },
      insertarMetadata: false,
      procedimientos,
    });
  };

  const showModalLoader = () => {
    const {
      getAutorizacionLoading,
      reactivarAutorizacionLoading,
      getProcedimientosPssLoading,
      validarProcedimientoLoading,
      crearAutorizacionLoading,
      descargarReporteVoucherLoading,
    } = props;

    return (
      getAutorizacionLoading ||
      reactivarAutorizacionLoading ||
      getProcedimientosPssLoading ||
      validarProcedimientoLoading ||
      crearAutorizacionLoading ||
      descargarReporteVoucherLoading
    );
  };

  const showCompleteButton = () => {
    return (
      String(dataAutorizacion?.tipoServicio) ===
      CODIGO_TIPO_SERVICIO_AUTORIZACION.EMERGENCIA
    );
  };

  const obtenerNumeroAutorizacionPrincipal = () => {
    const numeroAutorizacionPrincipal = esAutorizacionMadre
      ? autorizacionesRelacionadas?.autorizacionHumano
      : numeroAutorizacion;

    return numeroAutorizacionPrincipal !== null &&
      numeroAutorizacionPrincipal !== "null"
      ? numeroAutorizacionPrincipal
      : "";
  };

  return (
    <CustomLayout showMenuNav={true} footerPosition={"relative"}>
      <Section>
        <TittleLine
          title={`Datos de Reclamación ${obtenerNumeroAutorizacionPrincipal()}`}
          weight={"bold"}
        />
      </Section>

      <Section>
        <DetalleAfiliado {...dataAutorizacion} />
      </Section>

      <Section padding={"5px"}>
        <DetalleAutorizacion
          {...dataAutorizacion}
          prestadorEsPapperFree={
            props?.authUserData?.configuracionPaperFree?.esPaperFree
          }
        />
      </Section>

      <Section align="center" flexDirection={"column"} padding={"10px"}>
        <CheckRender
          allowed={
            esAutorizacionMadre ||
            (desdePantallaConsulta &&
              props?.getAutorizacionData?.mostrarMontosMadre)
          }
        >
          <CustomTable
            columns={columnsProcedimientosDetalleMadre(
              handleOpenModalCoberturas,
              empresa,
              onChangeCodigoCobertura,
              codigoCobertura,
              onChangeMontoCobertura,
              montoCobertura
            )}
            dataSource={tablaProcedimientosData}
            showPagination={false}
            pageSize={100}
            width={"200%"}
          />
        </CheckRender>

        <CheckRender
          allowed={
            !esAutorizacionMadre &&
            !props?.getAutorizacionData?.mostrarMontosMadre
          }
        >
          <CustomTable
            columns={columnsProcedimientosDetalle(
              handleOpenModalCoberturas,
              empresa,
              onChangeCodigoCobertura,
              codigoCobertura,
              onChangeMontoCobertura,
              montoCobertura
            )}
            dataSource={tablaProcedimientosData}
            showPagination={false}
            pageSize={100}
            width={"200%"}
          />
        </CheckRender>
      </Section>

      <Section>
        <TittleLine />
      </Section>

      <CheckRender allowed={!editMode}>
        <Section align={"center"} padding={"10px"}>
          <AutorizacionFormButtonsContainer>
            <CustomButton
              label={"Imprimir Voucher Matricial"}
              onClick={() => imprimirVoucher(true)}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Imprimir Voucher Térmico"}
              onClick={() => imprimirVoucher(false)}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CheckRender allowed={showCompleteButton()}>
              <CustomSeparator width={"10px"} />
              <CustomButton
                label={"Completar"}
                onClick={reactivar}
                isLoading={props.reactivarAutorizacionLoading}
                bgColor={empresa?.COLOR_SECUNDARIO}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                weight={"bold"}
              />
            </CheckRender>
          </AutorizacionFormButtonsContainer>
        </Section>
      </CheckRender>

      <CheckRender allowed={editMode}>
        <Section align={"center"} padding={"10px"}>
          <AutorizacionFormButtonsContainer>
            <CustomButton
              label={"Agregar Procedimiento"}
              onClick={agregarNuevoProcedimiento}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Enviar Reclamación"}
              onClick={modificarAutorizacion}
              bgColor={empresa?.COLOR_SECUNDARIO}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              weight={"bold"}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Cancelar"}
              onClick={reactivar}
              weight={"bold"}
              hoverColor={Colors.huMyHealth}
              bgColor={Colors.white}
              textColor={Colors.huMyHealth}
              border={`1px solid ${Colors.huMyHealth}`}
              isLoading={props.reactivarAutorizacionLoading}
            />
          </AutorizacionFormButtonsContainer>
        </Section>
      </CheckRender>

      <CustomModal
        isOpen={isModalCoberturasOpen}
        onClose={handleCloseModalCoberturas}
      >
        <ProcedimientosModal
          query={queryProcedimientos}
          onQueryChange={onQueryProcedimientosChange}
          columnsProcedimientos={columnsProcedimientosPermitidos(
            onClickProcedimientoModal,
            empresa
          )}
          dataProcedimientos={procedimientosBusqueda}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalRegistros={
            props?.getProcedimientosPssData?.paginacion?.totalRegistros
          }
        />
      </CustomModal>

      <CustomModal
        isOpen={showModalVouchers}
        onClose={handleCloseModalVouchers}
      >
        <Section align={"center"} padding={"10px"} flexDirection={"column"}>
          <CustomButton
            label={"Voucher Asegurado"}
            width={"250px"}
            onClick={() => descargarVoucherAsegurado()}
            isLoading={false}
            weight={"bold"}
            hoverColor={empresa?.COLOR_PRINCIPAL}
            bgColor={Colors.white}
            textColor={empresa?.COLOR_PRINCIPAL}
            border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
          />
          <CheckRender
            allowed={
              infoAutorizacionMadre?.autorizacionMadre
                ?.numeroReclamacionPrimera !== null
            }
          >
            <CustomSeparator height={"10px"} />
            <CustomButton
              label={"Voucher ARS Primera"}
              width={"250px"}
              onClick={() => descargarVoucherPrimeraPrestador()}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
          </CheckRender>
          <CheckRender
            allowed={
              infoAutorizacionMadre?.autorizacionMadre
                ?.numeroReclamacionHumano !== null
            }
          >
            <CustomSeparator height={"10px"} />
            <CustomButton
              label={"Voucher Humano Seguros"}
              width={"250px"}
              onClick={() => descargarVoucherHumanoPrestador()}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
          </CheckRender>
          <CustomSeparator height={"10px"} />
          <CustomButton
            label={"Imprimir Todo"}
            width={"250px"}
            onClick={() => descargarTodo()}
            isLoading={false}
            weight={"bold"}
            hoverColor={empresa?.COLOR_PRINCIPAL}
            bgColor={Colors.white}
            textColor={empresa?.COLOR_PRINCIPAL}
            border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
          />
        </Section>
      </CustomModal>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  getAutorizacionData: state.autorizacion.getAutorizacionData,
  getAutorizacionLoading: state.autorizacion.getAutorizacionLoading,
  getAutorizacionError: state.autorizacion.getAutorizacionError,

  reactivarAutorizacionData: state.autorizacion.reactivarAutorizacionData,
  reactivarAutorizacionLoading: state.autorizacion.reactivarAutorizacionLoading,
  reactivarAutorizacionError: state.autorizacion.reactivarAutorizacionError,

  descargarReporteVoucherLoading:
    state.autorizacion.descargarReporteVoucherLoading,

  validarProcedimientoData: state.procedimiento.validarProcedimientoData,
  validarProcedimientoLoading: state.procedimiento.validarProcedimientoLoading,
  validarProcedimientoError: state.procedimiento.validarProcedimientoError,

  crearAutorizacionData: state.autorizacion.crearAutorizacionData,
  crearAutorizacionLoading: state.autorizacion.crearAutorizacionLoading,
  crearAutorizacionError: state.autorizacion.crearAutorizacionError,

  getProcedimientosPssData: state.prestador.getProcedimientosPssData,
  getProcedimientosPssLoading: state.prestador.getProcedimientosPssLoading,
  getProcedimientosPssError: state.prestador.getProcedimientosPssError,

  getVoucherData: state.voucher.getVoucherData,
  getVoucherLoading: state.voucher.getVoucherLoading,
  getVoucherError: state.voucher.getVoucherError,

  getVoucherGmmData: state.voucher.getVoucherGmmData,
  getVoucherGmmLoading: state.voucher.getVoucherGmmLoading,
  getVoucherGmmError: state.voucher.getVoucherGmmError,
});

const mapDispatchToProps = {
  getAutorizacion: AutorizacionActions.getAutorizacion,
  descargarReporteVoucher: AutorizacionActions.descargarReporteVoucher,
  reactivarAutorizacion: AutorizacionActions.reactivarAutorizacion,
  validarProcedimiento: ProcedimientoActions.validarProcedimiento,
  crearAutorizacion: AutorizacionActions.crearAutorizacion,
  getProcedimientosPss: PrestadorActions.getProcedimientosPss,
  getVoucher: VoucherActions.getVoucher,
  getVoucherGmm: VoucherActions.getVoucherGmm,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DetalleAutorizacionScreen);
